import React from "react";
import { Block } from "../../lib/storyblok/types/story";
import HeroSectionUi from "../../ui/HeroSection";
import HeroBlock from "./Hero";
import LogoList from "./LogoList";
import { LogoListBlock } from "../../lib/storyblok/types/blocks/LogoListBlock";
import { HeroBlock as HeroBlockType } from "../../lib/storyblok/types/blocks/HeroBlock";

type HeroSectionProps = {
  blocks: Block[];
};

const HeroSection: React.FC<HeroSectionProps> = ({ blocks }) => {
  // Auto-detect if Hero Regular is followed by LogoList
  const hasLogoListBelow =
    blocks &&
    blocks.length >= 2 &&
    blocks[0].component === "hero" && // Only regular hero, not heroSmall
    blocks[1].component === "logoList";

  return (
    <HeroSectionUi hasLogoListBelow={hasLogoListBelow}>
      {blocks?.map((block) => {
        if (
          block.component === "hero" ||
          block.component === "heroVideo" ||
          block.component === "heroSmall" ||
          block.component === "heroVideoSmall"
        ) {
          return <HeroBlock key={block._uid} {...(block as HeroBlockType)} />;
        }
        if (block.component === "logoList") {
          return (
            <HeroSectionUi.LogoListWrapper key={block._uid}>
              <LogoList
                {...(block as LogoListBlock)}
                spacing="none"
                heroArea={true}
              />
            </HeroSectionUi.LogoListWrapper>
          );
        }
        return null;
      })}
    </HeroSectionUi>
  );
};

export default HeroSection;
